module.exports = __webpack_public_path__ + "img/diary-trainings.87922167.svg";